<template>
    <div>
        <CommonPopupFrame :changeHeight="100" :changeBottom="0" :isOpen="isOpenFeedBack" :closeCompleteAction="closeFeedBack">
            <div @click="closeFeedBack" style="padding-left: 12px; padding-top: 15px; font-size: 700; color: #808080; font-weight: 700; padding-bottom: 15px;">닫기</div>
            <div @touchmove.stop="() => {}" style="padding: 0 12px; padding-top: 16px; overflow-y: scroll; flex: 1;">
                <div style="text-align: center; font-weight: 700; font-size: 32px; line-height: 46px; margin-bottom: 40px;">피드백 보내기</div>
                <div style="display:flex; justify-content: center;">
                    <div @click="showFiles">
                        <img :src="require('@/assets/img/soccerhow_write_album.png')" style="width:80px; height:80px; margin-bottom: 8px;">
                        <div style="text-align:center; font-size:12px; font-weight:500; color:#210F03;">앨범</div>
                    </div>
                </div>
                <div style="padding-top: 12px;">
                    <SoccerHowWriteFormImageSlider ref="image_slider" :img-src-arr="imgSrcArr" :detect-delete-image-one="detectDeleteImageOne" :is-delete-bottom="true" />
                </div>
                <div style="font-size: 12px;font-weight: 500;line-height: 20px; color: #606060; text-align: center; margin-top: 6px;">미디어를 첨부하여 피드백 내용을 자세하게 설명할 수 있습니다</div>
                <div style="margin-top: 30px;">
                    <div style="border-bottom:1px solid #EBEBEB;">
                        <input type="text" :placeholder="'제목을 입력하세요'" style="border:0px; outline:none; width:100%; font-size:16px;color:black; padding: 10px 0px;" v-model="title" @input="handleTextAreaInput" />
                    </div>
                    <textarea ref="elTextArea" class="contents_textarea" :placeholder="'내용을 입력하세요'" style="line-height: 20px; border: none; outline: none; font-size:15px;color:black;resize:none; overflow-y: scroll; width:100%; white-space: pre-wrap; padding: 10px 0; max-height: 200px; margin-top: 6px;" v-model="contents" @input="handleTextAreaInput" oninput='this.style.height = ""; this.style.height = (this.scrollHeight) + "px"'></textarea>
                </div>
            </div>
            <div style="height: 93px; padding: 0 12px;">
                <div @click="submitFeedBack" class="common_btn" :class="contents === '' ? 'un_active' : 'active'" style="">피드백 전송하기</div>
            </div>
            <input type="file" style="display:none;" ref="file" data-id="file" @change="readURL($event)" :accept="'image/*'">
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from "@/components/modal/my/CommonPopupFrame"
import SoccerHowWriteFormImageSlider from "@/components/common/SoccerHowWriteFormImageSlider"
import ResponseCode from "@/ResponseCode"

export default {
    name: 'FeedBackWriteForm',
    components: {CommonPopupFrame, SoccerHowWriteFormImageSlider},
    props: {
        isOpenFeedBack: {
            type: Boolean,
            default: false
        },
        closeFeedBack: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            contents: '',
            imgSrcArr: [],
            title: ''
        }
    },
    methods: {
        detectDeleteImageOne(index) {
            this.$refs[this.imgSrcArr[index].id].value = '';
        },
        showFiles() {
            if (this.imgSrcArr.length >= 1) {
                alert('최대 1개까지 업로드 가능합니다.');
                return;
            }
            this.$refs['file'].click();
        },
        readURL(e) {
            const input = e.currentTarget;

            if (input.files && input.files[0]) {
                var extension = input.files[0].name.split('.').pop().toLowerCase();

                if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp' || extension === 'mp4' || extension === 'mov' || extension === 'qt') {

                    var reader = new FileReader();
                    reader.onload = (e) => {
                        if (input.files[0].size > 1024 * 1024 * 1024) {
                            input.files[0].value = '';
                            this.$GlobalStore.showAlert('업로드 가능한 용량은 최대 1GB 입니다.');
                            return;
                        }

                        const data = { src: e.target.result, id: input.getAttribute('data-id'), isFileTag: true, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
                        if (extension === 'mp4' || extension === 'mov' || extension === 'qt') data.src = require('@/assets/this_is_video.png');
                        this.imgSrcArr = [...this.imgSrcArr, data];
                        console.log(this.imgSrcArr)

                        this.$refs.image_slider.__refreshWhenImageAdded();

                    }
                    reader.readAsDataURL(input.files[0]);
                } else {
                    this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp, mp4, mov, qt만 업로드 가능합니다.');
                }
            }
        },
        handleTextAreaInput() {
            if (this.contents.length > 500 || this.title.length > 40) {
                this.contents = this.contents.slice(0, 500)
                this.title = this.title.slice(0, 40)
            }
        },
        async submitFeedBack() {
            if (this.title === '') {
                this.$GlobalStore.showAlert('제목을 입력해주세요.')
                return
            }

            if (this.contents === '') {
                this.$GlobalStore.showAlert('내용을 입력해주세요.')
                return
            }
            this.$GlobalStore.showProgress()

            const formData = new FormData()
            formData.append('title', this.title)
            formData.append('contents', this.contents)
            if (this.imgSrcArr.length > 0) {
                formData.append('file0', this.$refs[this.imgSrcArr[0].id].files[0])
            }

            const res = await this.$Axios.post('/api/feedback/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

            if (res.data.code === ResponseCode.SUCCESS) {
                this.closeFeedBack()
                this.$GlobalStore.hideProgress()
                this.$GlobalStore.showToastVer2('피드백 전송 완료')
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
                this.$GlobalStore.hideProgress()
            }
        }
    },
    created() {
        this.submitFeedBack = this.$Once(this.submitFeedBack);
    }
}
</script>

<style scoped>
.common_btn {
    margin-top: 12px;
    text-align: center;
    line-height: 48px;
    height: 48px;
    border-radius: 12px;
    font-weight: 500;
    font-size: 14px;
}
.active {
    background-color: #210f03;
    color: #fff;
}

.un_active {
    background-color: #f5f5f5;
    color: #d9d9d9;
}

textarea::placeholder {
    font-size: 14px;
    color: #bbbbbb;
}

input::placeholder {
    color: #bbbbbb;
}
</style>